/* eslint-disable no-restricted-imports */
import { Dialog as MuiDialog, DialogProps as MuiDialogProps } from '@material-ui/core';
import { dialogStyles } from './dialogCssDefs';

export type DialogProps = MuiDialogProps;

/**
 * @deprecated Deprecated — use pantry Modal instead.
 * @see https://docs.tocktix.com/pantry?path=/docs/components-modal--docs
 * Migration: Replace Dialog with the pantry Modal component.
 */
export const Dialog = (props: DialogProps) => {
  return (
    <MuiDialog css={dialogStyles} {...props} PaperProps={{ elevation: 2, ...props.PaperProps }} />
  );
};
